import React, { Component } from 'react';
import Icon from '../../../../components/Icon';
import CountryLabel from '../../../../components/CountryLabel';
import ListRow from '../../../../components/List/Row';
import ListHeader from '../../../../components/List/Header';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';
import TooltipCustom from '../../../../components/Tooltip';
import ContentTooltip from '../../../../components/ContentTooltip';

const MarketListContainer = styled.div`
  .zoneItemIcon {
    margin-left: 18px;
    margin-right: 31px;
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .zoneItemIconDisabled {
    margin-left: 18px;
    margin-right: 26px;
    color: #868e96;
    width: 17px;
    height: 17px;
  }

  .marketListCheckbox {
    width: 10%;
    height: 100%;
    display: flex;
    justify-content: center;
  }

  .marketListTitle {
    width: 25%;
    padding-left: 15px;
    display: flex;
    align-items: center;
    font-size: 12px;
    height: 100%;
  }

  .marketListTitleDisabled {
    width: 25%;
    padding-left: 30px;
    opacity: 0.5;
  }

  .marketListTitleItem {
    font-family: 'SFCompactText', sans-serif;
    font-weight: bold;
    color: #1e3647;
    font-size: 12px;
  }

  .marketListTitleItemDisabled {
    color: grey;
  }

  .marketListDistribution {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 12px;
    width: 65%;
  }

  .marketListDistributionItem {
    font-family: 'SFCompactText', sans-serif;
    font-size: 12px;
  }

  .marketListDistributionItemDisabled {
    color: grey;
  }

  .marketListDistributionSubTitle {
    font-weight: lighter;
    font-style: italic;
    font-family: 'SFCompactText', sans-serif;
  }

  .marketListDistributionSubTitleRed {
    color: #3a3a3a;
    text-decoration: underline;
  }

  .marketList {
    max-height: 450px;
    overflow-y: auto;
  }

  .tooltipContainer {
    margin-left: auto;
    margin-right: 30px;
  }
`;

export default class MarketList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markets: []
    };
  }

  componentDidMount() {
    this.setState({ markets: this.props.markets });
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props && this.props.markets !== prevProps.markets) {
      this.setState({ markets: this.props.markets });
    }
  }

  sortColumn(key) {
    let { markets, sortAscending } = this.state;
    markets.sort(function (a, b) {
      return a[key].localeCompare(b[key]);
    });
    if (sortAscending) {
      this.setState({ markets, sortAscending: !sortAscending });
    } else {
      this.setState({
        markets: markets.reverse(),
        sortAscending: !sortAscending
      });
    }
  }

  render() {
    const { markets } = this.state;

    return (
      <MarketListContainer>
        <ListHeader
          columns={[
            {
              center: true,
              length: '10%',
              noBorder: true
            },
            {
              name: I18n.t('admin.marketColumns.market'),
              sort: true,
              length: '25%',
              onSort: () => this.sortColumn('market_name')
            },
            {
              name: I18n.t('admin.marketColumns.network'),
              sort: true,
              length: '65%',
              onSort: () => this.sortColumn('network_code')
            }
          ]}
        />
        <div className="marketList">
          {markets.map((market, index) => (
            <ListRow
              dark={index % 2 === 0}
              disabled={!market.has_access}
              key={`marketRow-${index}`}
            >
              <div className="marketListCheckbox">
                <div
                  className={
                    !market.has_access ? 'zoneItemIconDisabled' : 'zoneItemIcon'
                  }
                >
                  <Icon icon={!market.has_access ? 'close' : 'check'} />
                </div>
              </div>
              <div className="marketListTitle">
                <p className="marketListTitleItem">{market.market_name}</p>
                <CountryLabel onlyFlag name={market.country_code} />
              </div>
              <div className="marketListDistribution">
                {market.has_access ? (
                  <p className="marketListDistributionItem">
                    {market.network_code === 'ON'
                      ? I18n.t('restaurantsMaj')
                      : I18n.t('wineShopsMaj')}
                  </p>
                ) : (
                  <p className="marketListDistributionItem marketListDistributionItemDisabled">
                    {market.network_code === 'ON'
                      ? I18n.t('restaurantsMaj')
                      : I18n.t('wineshopsMaj')}{' '}
                    <span className="marketListDistributionSubTitle">
                      ({I18n.t('admin.marketColumns.notIncluded')}) -{' '}
                      <span className="marketListDistributionSubTitle marketListDistributionSubTitleRed">
                        {I18n.t('admin.marketColumns.contact')}
                      </span>
                    </span>
                  </p>
                )}
                {market.users && market.users.length > 0 && (
                  <div className="tooltipContainer">
                    <TooltipCustom
                      placement="top"
                      content={
                        <ContentTooltip
                          title="Utilisateurs ayant accès"
                          values={market.users}
                        />
                      }
                    />
                  </div>
                )}
              </div>
              <div />
            </ListRow>
          ))}
        </div>
      </MarketListContainer>
    );
  }
}
